import React, { useRef, useState } from "react";
import styles from "./index.module.scss";
import RichEditor from "./RichEditor/RichEditor";
import { Button, Modal, Select, Tooltip, message } from "antd";
import ImageCropper from "../ImageCropper/ImageCropper";
import { InformationIcon } from "../../assets/Logos/Icons";
import { Assets } from "../../assets/Assets";
// import CreateDoctorList from "./CreateDoctorList/CreateDoctorList";

function ManageDepartmentProfile() {
  const [imageUploadModal, setImageUploadModal] = useState(false);
  const [sampleImageModal, setSampleImageModal] = useState(false);
  const imageRef = useRef();

  const [formData, setFormData] = useState({
    overView: "",
    specialities: "",
    doctors: [],
    services: "",
    faq: "",
    image: null,
  });

  const options = [];
  for (let i = 10; i < 36; i++) {
    options.push({
      label: "Doctor" + i,
      value: "Doctor" + i,
    });
  }

  const handleChangeOverView = (e) =>
    setFormData((prev) => {
      return { ...prev, overView: e };
    });

  const handleChangeSpeciality = (e) =>
    setFormData((prev) => {
      return { ...prev, specialities: e };
    });

  const handleChangeServices = (e) =>
    setFormData((prev) => {
      return { ...prev, Services: e };
    });

  const handleChangeFaq = (e) =>
    setFormData((prev) => {
      return { ...prev, faq: e };
    });

  // const handleAddDoctor = () => {
  //   let lastItem = formData?.doctors.at(-1);
  //   let nextIndex = 0;
  //   if (lastItem) nextIndex = lastItem.index + 1;
  //   setFormData({
  //     ...formData,
  //     doctors: [
  //       ...formData?.doctors,
  //       {
  //         index: nextIndex,
  //         name: "",
  //         speciality: "",
  //         details: "",
  //       },
  //     ],
  //   });
  // };
  // const handleRemoveDoctor = (removeIndex) => {
  //   console.log({
  //     removeIndex,
  //     doctors: formData.doctors,
  //   });
  //   let removedArray = formData.doctors.filter((e) => e.index != removeIndex);
  //   console.log(removedArray);
  //   setFormData({
  //     ...formData,
  //     doctors: removedArray,
  //   });
  // };
  // const handleOnChangeDoctor = (e, key, index) => {
  //   let { value } = e?.target;
  //   let _doctors = formData?.doctors;
  //   _doctors.map((each) => {
  //     if (each.index == index) {
  //       each[key] = value;
  //     }
  //   });

  //   setFormData({
  //     ...formData,
  //     doctors: _doctors,
  //   });
  // };

  const handleChangeDoctors = (e) => {
    setFormData({
      ...formData,
      doctors: e,
    });
  };

  const onSelectDepartmentImage = (e) => {
    if (e.target.files[0]) {
      if (validateImage(e)) {
        setFormData({ ...formData, image: e.target.files[0] });
        setImageUploadModal(true);
      }
    }
  };

  const forceUploadImage = () => {
    imageRef?.current?.click();
  };

  const handleRemoveImage = () => {
    setFormData({ ...formData, image: null });
  };

  const manageImageUploadModalView = (flag) =>
    setImageUploadModal(flag ? flag : false);

  const manageSampleImageModalView = (flag) =>
    setSampleImageModal(flag ? flag : false);

  function onImageUpload(imageBlob) {
    console.log({ imageBlob });
    setFormData({
      ...formData,
      image: imageBlob,
    });
    manageImageUploadModalView(false);
  }

  function validateImage(event) {
    const file = event.target.files[0];
    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
    const maxSize = 1 * 1024 * 1024; // 1 MB in bytes

    // Check if the file is an image
    if (!allowedExtensions.test(file.name.toLowerCase())) {
      message.error("Please select a valid image file (JPEG, JPG, PNG, GIF).");
      imageRef.current.value = null;
      // alert("Please select a valid image file (JPEG, JPG, PNG, GIF).");
      return false;
    }

    // Check if the file size exceeds the limit
    if (file.size > maxSize) {
      message.error("File size exceeds the limit of 1 MB.");
      imageRef.current.value = null;
      // alert("File size exceeds the limit of 1 MB.");
      return false;
    }

    return true;

    // File is valid
    // You can perform additional actions here, such as displaying a preview of the image
    // or submitting the form.
  }

  return (
    <div className={styles.container}>
      <h6>Create new department profile</h6>
      <div className={styles.devider}></div>

      <div className={styles.form_section_wrap}>
        <div className={styles.form_section}>
          <div className={styles.form_label}>Specialty Name:</div>
          <div className={styles.form_content}>
            <Select
              placeholder="Select speciality"
              style={{ width: "250px" }}
              options={[
                {
                  value: "Speciality 1",
                  label: "Speciality 1",
                },
                {
                  value: "Speciality 2",
                  label: "Speciality 2",
                },
                {
                  value: "Speciality 3",
                  label: "Speciality 3",
                },
              ]}
            />
          </div>
        </div>
      </div>

      <div className={styles.devider}></div>

      <div className={styles.form_section_wrap}>
        <div className={styles.form_section}>
          <div className={styles.form_label}>
            Department Image:
            <div className={styles.tooltip_wrap}>
              <Tooltip
                placement="top"
                title={
                  "Image size cannot exceed more than 1MB. Allow all image formats."
                }
              >
                <div>
                  <InformationIcon />
                </div>
              </Tooltip>
            </div>
          </div>
          <div className={styles.form_content}>
            <input
              ref={imageRef}
              accept="image/*"
              style={{ display: "none" }}
              type="file"
              onChange={onSelectDepartmentImage}
            />
            {formData?.image ? (
              <div className="d-flex flex-row align-items-end">
                <img
                  className={styles.department_image}
                  src={URL.createObjectURL(formData?.image)}
                  alt="cover_image"
                />
                <div
                  className="d-flex flex-column align-items-center justify-content-center"
                  style={{ gap: "8px" }}
                >
                  <div
                    style={{ marginLeft: "15px", cursor: "pointer" }}
                    onClick={handleRemoveImage}
                  >
                    <i class="fal fa-trash" />
                  </div>

                  <div
                    style={{ marginLeft: "15px", cursor: "pointer" }}
                    onClick={forceUploadImage}
                  >
                    <i class="fal fa-pencil" />
                  </div>
                </div>
              </div>
            ) : (
              <div className={styles.upload_button_container}>
                <Button
                  className={styles.image_upload_btn}
                  onClick={forceUploadImage}
                >
                  Upload image
                </Button>

                <h6
                  onClick={() => {
                    manageSampleImageModalView(true);
                  }}
                >
                  Sample
                </h6>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={styles.devider}></div>

      <div className={styles.form_section_wrap}>
        <div className={styles.form_section}>
          <div className={styles.form_label}>Overview:</div>
          <div className={styles.form_content}>
            <RichEditor
              value={formData?.overView}
              handleChangeValue={handleChangeOverView}
            />
          </div>
        </div>
      </div>

      <div className={styles.devider_form}></div>

      <div className={styles.form_section_wrap}>
        <div className={styles.form_section}>
          <div className={styles.form_label}>Specialties:</div>
          <div className={styles.form_content}>
            <RichEditor
              value={formData?.specialities}
              handleChangeValue={handleChangeSpeciality}
            />
          </div>
        </div>
      </div>

      <div className={styles.devider_form}></div>

      <div className={styles.form_section_wrap}>
        <div className={styles.form_section}>
          <div className={styles.form_label}>Doctors:</div>
          <div className={styles.form_content}>
            {/* <CreateDoctorList
              value={formData?.doctors}
              handleAddDoctor={handleAddDoctor}
              handleRemoveDoctor={handleRemoveDoctor}
              handleOnChangeDoctor={handleOnChangeDoctor}
            /> */}
            <Select
              className={styles.doctor_select}
              mode="multiple"
              allowClear
              style={{
                width: "100%",
              }}
              placeholder="Please select doctors"
              onChange={handleChangeDoctors}
              options={options}
            />
          </div>
        </div>
      </div>

      <div className={styles.devider_form}></div>

      <div className={styles.form_section_wrap}>
        <div className={styles.form_section}>
          <div className={styles.form_label}>Services:</div>
          <div className={styles.form_content}>
            <RichEditor
              value={formData?.services}
              handleChangeValue={handleChangeServices}
            />
          </div>
        </div>
      </div>

      <div className={styles.devider_form}></div>

      <div className={styles.form_section_wrap}>
        <div className={styles.form_section}>
          <div className={styles.form_label}>FAQ:</div>
          <div className={styles.form_content}>
            <RichEditor
              value={formData?.faq}
              handleChangeValue={handleChangeFaq}
            />
          </div>
        </div>
      </div>

      <div className={styles.devider_form}></div>
      <div className={styles.footer}>
        <button>CREATE DEPARTMENT</button>
      </div>
      <div className={styles.devider_form}></div>

      <ImageCropper
        imageData={formData?.image}
        isOpen={imageUploadModal}
        handleClose={() => {
          manageImageUploadModalView(false);
        }}
        handleSubmit={onImageUpload}
      />

      <SampleDepartmentProfileModal
        isOpen={sampleImageModal}
        handleClose={() => {
          manageSampleImageModalView(false);
        }}
      />
    </div>
  );
}

export default ManageDepartmentProfile;

const SampleDepartmentProfileModal = ({ isOpen = false, handleClose }) => {
  return (
    <Modal
      footer={false}
      closeIcon={<></>}
      open={isOpen}
      onCancel={handleClose}
      className={styles.sample_modal}
    >
      <img
        src={Assets.departmentProfileSample}
        alt="department_profile_sample"
      />

      <p>
        * Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque
        asperiores omnis eos perspiciatis tempora officia laboriosam nesciunt
        voluptate obcaecati a.
      </p>

      <button onClick={handleClose} className={styles.close_btn}>
        Close
      </button>
    </Modal>
  );
};
